import { type Color } from '../../theme';
import colorManipulation from '../tinyColor';

const adjustColorOnDark = (isDark: boolean, color: Color | string, amt = 30) =>
  colorManipulation[isDark ? 'lighten' : 'darken'](color, amt);

export default adjustColorOnDark;
